// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { Headings, MarkdownBlock } from '../../shared/textComponents/TextComponents';
import NavContainer from '../../shared/nav/NavContainer';
import noteActions from '../../../actions/noteActions';
import type { PageProps, State } from '../../../lib/types';
import './GotQuestions.scss';

type GotQuestionsProps = PageProps & {
  notesInRedux: string,
  navLinks: [string],
};

const GotQuestions = (props: GotQuestionsProps): React.Element<*> => {
  const { content, locale, navLinks, onSave, notesInRedux } = props;
  const headingMD = `# ${content.notes.headerText}`;
  const conditionalNavContent = {
    ...content.navigation,
    nextText: notesInRedux ? content.navigation.nextText : content.noQuestionsNextText
  };

  return (
    <>
      <Headings isAutoFocusing str={headingMD} />
      <MarkdownBlock str={content.notes.longDescriptionFirst} />
      <MarkdownBlock str={content.notes.longDescriptionSecond} />
      <div className="textarea-container">
        {notesInRedux === '' && (
          <div className="placeholder" aria-hidden>
            <MarkdownBlock str={content.notes.placeholder} />
          </div>
        )}
        <textarea
          value={notesInRedux}
          onChange={(e: React.SyntheticEvent) => { onSave(e.target.value); }}
          placeholder={notesInRedux || content.notes.placeholder}
        />
      </div>
      <NavContainer
        locale={locale}
        nextPage={navLinks[1]}
        backPage={navLinks[0]}
        notesContent={notesInRedux}
        navigationContent={conditionalNavContent}
        hideNotes
      />
    </>
  );
};

const mapStateToProps = (state: State): Object => ({ notesInRedux: state.notesReducer.notes });

const mapDispatchToProps = noteActions;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GotQuestions);
